import types from './types';

const InitialState = {
    modal: null
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.open:
            return {
                ...state,
                modal: payload
            }
        case types.close:
            return {
                ...state,
                modal: null
            }
        default:
            return state;
    }
}